import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { AccountType } from '../store/offer';

export function isRentDepartment({ accountType }: IAgentSchema) {
  return accountType === AccountType.RentDepartment;
}
